<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}个{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" type="danger" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">
            批量删除
          </el-button>
          <el-button class="btn" size="small" v-preventReClick @click="handleExport">
            数据导出
          </el-button>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span class="reset" v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column type="selection" :reserve-selection="true" fixed align="center" width="55">
        </el-table-column>
        <el-table-column prop="name" label="维修厂商名称" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span><br />
            <span>{{ scope.row.no }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="creditCode" label="组织机构代码" width="180"></el-table-column>
        <el-table-column prop="code" label="所在省/市" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.countryName }}</span>
            <span v-if="scope.row.provinceName">{{
              "/" + scope.row.provinceName
            }}</span>
            <span v-if="scope.row.cityName">{{
              "/" + scope.row.cityName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="contactor" label="联系人"></el-table-column>
        <el-table-column prop="phone" label="联系电话" show-overflow-tooltip></el-table-column>
        <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
        <el-table-column prop="stateName" label="状态" width="80">
          <template slot-scope="scope">
            <span :class="{
                enable: scope.row.state == 1,
                forbidden: scope.row.state == 0,
              }">{{ scope.row.stateName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operation" width="100" label="操作" show-overflow-tooltip>
          <template slot-scope="scope">
            <!-- <el-button type="text" v-preventReClick
            @click="handleUpdate(scope.row)" class="color-blue">查看详情</el-button> -->
            <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="color-blue">编辑</el-button>
            <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" class="margin-left20 color-blue" v-preventReClick @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { GetRepairManufacturers, RemoveRepairManufacturers } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin";

export default {
  components: {},
  mixins: [GetDataMixin],
  data () {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
      },
      // 新增和编辑都可写
      editMode: false,
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // // 新增启用开关
      // iso: true,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      // 列表多选
      multiple: true,
    };
  },
  methods: {
    handleSelectionChange (selection) {
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
      // this.ids = val;
    },
    // 获取列表
    getData () {
      GetRepairManufacturers(this.query).then((res) => {
        this.tableData = res.returnData.data;
        this.total = res.returnData.totalCount;
      });
    },
    // 新建
    handleAdd () {
      // this.editMode = true
      // this.open = true
      // this.title = "新建"
      // this.resetForm()

      // this.$router.push("/repair-manufacturer-edit?formMode=1");
      this.routePushWithParams("/repair-manufacturer-edit", this.query, { formMode: 1, id: row.id });
    },
    handleExport () {
      // alert("点击了导出按钮");
    },
    // 编辑
    handleUpdate (row) {
      // this.resetForm()
      // this.form = JSON.parse(JSON.stringify(row));
      // this.open = true;
      // this.title = "编辑"
      // this.$router.push(
      //   "/repair-manufacturer-edit?id=" + row.id + "&formMode=2"
      // );
      this.routePushWithParams("/repair-manufacturer-edit", this.query, { formMode: 2, id: row.id });
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },
    // 删除部门
    handleDelete (row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("确认要删除吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          return RemoveRepairManufacturers({ ids });
        })
        .then(() => {
          this.$my_message(`删除成功`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset () {
      this.query.keyWord = "";
      this.$set(this.query, "pageIndex", 1);
      this.$set(this.query, "pageSize", 10);
      this.ids = []
      this.multipleSelection = []
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
  },
  created () {
    // 分页组件默认值需要早created
    if (this.$route.params) {
      this.query = this.$route.params
    }
  },
  mounted () {
    // 查询组件默认值需要在mounted
    // if (this.$route.params) {
    //   this.$refs["selectFilter"].query = this.query
    // }
    this.getData();
  },
};
</script>

<style lang="scss" scoped></style>
